import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import EnquiryForm from "./EnquiryForm";

export default function GlobalEnquiryPopup() {
    const [showPopup, setShowPopup] = useState(false);
    const location = useLocation();

    useEffect(() => {
        // Reset popup state on route change
        setShowPopup(false);

        // Auto show popup on every page visit after a short delay
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 1500);

        return () => clearTimeout(timer);
    }, [location.pathname]);

    return (
        <>
            <AnimatePresence>
                {showPopup && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
                        onClick={() => setShowPopup(false)}
                    >
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            transition={{ duration: 0.3 }}
                            onClick={(e) => e.stopPropagation()}
                            className="relative w-full max-w-md sm:max-w-lg"
                        >
                            <EnquiryForm onClose={() => setShowPopup(false)} />
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>

            {/* Floating Enquire Now Button on the right edge */}
            <motion.button
                initial={{ x: 100 }}
                animate={{ x: 0 }}
                transition={{ delay: 1 }}
                onClick={() => setShowPopup(true)}
                className="fixed top-1/2 right-0 -translate-y-1/2 z-[99999] bg-[#EAB308] text-black border-4 border-black border-r-0 px-2 py-4 rounded-l-xl shadow-2xl hover:bg-[#CA8A04] transition-colors flex items-center justify-center group"
                style={{ writingMode: "vertical-rl", textOrientation: "mixed" }}
            >
                <span className="transform rotate-180 font-bold tracking-widest text-sm sm:text-base uppercase">
                    ENQUIRE NOW
                </span>
            </motion.button>
        </>
    );
}
